import _ from 'lodash'
import ShipmentUnit from './ShipmentUnit'

export default class Shipment {
  id = null
  arrivalDate = null
  receiptDoc = null
  load = null
  sender = null
  marking = null
  recipient = null
  payer = null
  status = null
  transportId = null
  transportType = null
  recipientAddress = null
  time = null
  driver = null
  shipments = []

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field)) {
        this[field] = value
      }
    })

    if (data.shipments) {
      this.shipments = _.map(data.shipments, shipment => new ShipmentUnit(shipment))
    }
  }
}
